var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveListView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.375977 0H26.376C28.5851 0 30.376 1.79086 30.376 4V28C30.376 30.2091 28.5851 32 26.376 32H0.375977V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.376 10.75H22.126V12.25H12.376V10.75ZM8.62598 10.375H10.876V12.625H8.62598V10.375ZM8.62598 14.875H10.876V17.125H8.62598V14.875ZM8.62598 19.375H10.876V21.625H8.62598V19.375ZM12.376 15.25H22.126V16.75H12.376V15.25ZM12.376 19.75H22.126V21.25H12.376V19.75Z",
    fill: "#C6C6C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveListView);
export default __webpack_public_path__ + "static/media/ActiveListView.33a89462d9465656dd51f0a5938ce050.svg";
export { ForwardRef as ReactComponent };